import { Component, Input, OnInit } from '@angular/core';
import { ConsultaBandejaProgramadorI } from 'src/app/infraestructure/models/consultaBandejaProgramador.interface';

@Component({
  selector: 'app-table-consult-programmer',
  templateUrl: './table-consult-programmer.component.html',
  styleUrls: ['./table-consult-programmer.component.scss']
})
export class TableConsultProgrammerComponent implements OnInit{

  @Input() dataTable: ConsultaBandejaProgramadorI[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  descargarArchivo(base64: string, solicitudId: number): void {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `Soporte solicitud #${solicitudId}`;

    // Agrega el enlace al DOM y haz clic en él para iniciar la descarga
    document.body.appendChild(a);
    a.click();

    // Limpia el enlace y la URL
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
